import { render, staticRenderFns } from "./Ending.vue?vue&type=template&id=bc8c7ed6&scoped=true&"
import script from "./Ending.vue?vue&type=script&lang=js&"
export * from "./Ending.vue?vue&type=script&lang=js&"
import style0 from "./Ending.vue?vue&type=style&index=0&id=bc8c7ed6&lang=less&scoped=true&"
import style1 from "./Ending.vue?vue&type=style&index=1&id=bc8c7ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8c7ed6",
  null
  
)

export default component.exports